import ApiClient from "../api/apiClient";

const CPDSACTIVITIES = "/cpds";
const ATP_PROFILE = "/user/atp-profile";
const CPDS = "/cpds";
const CPDS_ = "/cpds/";
const RESOURCES = "/atp_resources/";
const SUBSCRIPTION = "/atp/subscription";
const CPDS_COUNTS = "/cpds/get-cpd-activity-status-count";
const EXCEL_ACTIVITIES = "/cpds/get-cpd-activity-excel";

const createActivity = (data) => {
    return ApiClient.post(CPDSACTIVITIES, data);
};

const getAtpPofile = () => {
    return ApiClient.get(ATP_PROFILE);
};

const updateAtpProfile = (data) => {
    return ApiClient.put(ATP_PROFILE, data);
};

const getCPDS = ({
    page,
    limit,
    cpd_status,
    start_date,
    end_date,
    title,
    location,
    duration_time,
    duration_type,
    date_time,
    tech_field,
    target_audience,
    type_of_cpd,
    web_url,
    description,
    approval_id,
    approval_date,
    sort,
    order,
}) => {
    const baseUrl = `${CPDS}?`;

    let queryParams = "";

    // Add mandatory parameters
    queryParams += `page=${page}&limit=${limit}&cpd_status=${cpd_status}&start_date=${start_date}&end_date=${end_date}&sort=${sort}&order=${order}`;

    // Add optional parameters if present
    if (title) queryParams += `&title=${title}`;
    if (location) queryParams += `&location=${location}`;
    if (duration_time) queryParams += `&duration_time=${duration_time}`;
    if (duration_type) queryParams += `&duration_type=${duration_type}`;
    if (date_time) queryParams += `&date_time=${date_time}`;
    if (tech_field) queryParams += `&tech_field=${tech_field}`;
    if (target_audience) queryParams += `&target_audience=${target_audience}`;
    if (type_of_cpd) queryParams += `&type_of_cpd=${type_of_cpd}`;
    if (web_url) queryParams += `&web_url=${web_url}`;
    if (description) queryParams += `&description=${description}`;
    if (approval_id) queryParams += `&approval_id=${approval_id}`;
    if (approval_date) queryParams += `&approval_date=${approval_date}`;

    const url = baseUrl + queryParams;

    return ApiClient.get(url);
};

const getCPDSCounts = ({
    cpd_status,
    start_date,
    end_date,
    title,
    location,
    duration_time,
    duration_type,
    date_time,
    tech_field,
    target_audience,
    type_of_cpd,
    web_url,
    description,
    approval_id,
    approval_date,
    sort,
    order,
}) => {
    const baseUrl = `${CPDS_COUNTS}?`;

    let queryParams = "";

    // Add mandatory parameters
    queryParams += `cpd_status=${cpd_status}&start_date=${start_date}&end_date=${end_date}&sort=${sort}&order=${order}`;

    // Add optional parameters if present
    if (title) queryParams += `&title=${title}`;
    if (location) queryParams += `&location=${location}`;
    if (duration_time) queryParams += `&duration_time=${duration_time}`;
    if (duration_type) queryParams += `&duration_type=${duration_type}`;
    if (date_time) queryParams += `&date_time=${date_time}`;
    if (tech_field) queryParams += `&tech_field=${tech_field}`;
    if (target_audience) queryParams += `&target_audience=${target_audience}`;
    if (type_of_cpd) queryParams += `&type_of_cpd=${type_of_cpd}`;
    if (web_url) queryParams += `&web_url=${web_url}`;
    if (description) queryParams += `&description=${description}`;
    if (approval_id) queryParams += `&approval_id=${approval_id}`;
    if (approval_date) queryParams += `&approval_date=${approval_date}`;

    const url = baseUrl + queryParams;

    return ApiClient.get(url);
};

const getCPDById = (id) => {
    const url = CPDS_ + id;
    return ApiClient.get(url);
};

const updateCPD = (id, data) => {
    const url = CPDS_ + id;
    return ApiClient.put(url, data);
};

const deleteCPD = (id) => {
    const url = CPDS_ + id;
    return ApiClient.delete(url);
};

const getResources = () => {
    return ApiClient.get(RESOURCES);
};

const getAtpSubscription = (id) => {
    return ApiClient.get(SUBSCRIPTION);
};

const getAtpExcel = (start_date,
    end_date) => {
    const baseUrl = `${EXCEL_ACTIVITIES}?`;
    let queryParams = "";

    // Add mandatory parameters
    queryParams += `start_date=${start_date}&end_date=${end_date}`;
    const url = baseUrl + queryParams;
    return ApiClient.get(url);
};
export const atpService = {
    createActivity,
    getAtpPofile,
    updateAtpProfile,
    getCPDS,
    getCPDById,
    updateCPD,
    deleteCPD,
    getResources,
    getAtpSubscription,
    getCPDSCounts,
    getAtpExcel
};
